import styled from "styled-components";

export const ProfileHeaderWrapper = styled.div`
  background: #fff;
  border: 1px solid #e8eee5;
  border-radius: 18px;
  position: relative;
  box-shadow: 0 4px 18px rgba(28,38,52,0.05);
  overflow: hidden;
  font-family: 'Poppins', sans-serif;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 4px;
    background: linear-gradient(90deg, #509540, #6dd05a);
  }

  .ph-top {
    display: flex;
    gap: 24px;
    padding: 28px 28px 22px;
    align-items: flex-start;
  }

  .ph-avatar {
    position: relative;
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background: linear-gradient(135deg, #509540, #3d7a30);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 10px 24px rgba(80,149,64,0.30);
    border: 4px solid #fff;
    outline: 1px solid #d8eed2;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }

    .ph-initial {
      color: #fff;
      font-size: 38px;
      font-weight: 800;
      letter-spacing: -1px;
    }

    .ph-status-dot {
      position: absolute;
      bottom: 4px;
      right: 4px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #f59e0b;
      border: 3px solid #fff;
    }
  }

  .ph-info {
    flex: 1;
    min-width: 0;
  }

  .ph-name {
    font-size: 1.3rem;
    font-weight: 800;
    color: #1C2634;
    line-height: 1.2;
    margin-bottom: 4px;
  }

  .ph-tagline {
    font-size: 13px;
    color: #6f7878;
    margin-bottom: 16px;
  }

  .ph-chips {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    max-width: 560px;
  }

  .ph-chip {
    background: #f8fbf6;
    border: 1px solid #e3eedd;
    border-radius: 12px;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: all 0.2s;
  }

  .ph-chip:hover {
    border-color: #509540;
    background: #eef7eb;
  }

  .ph-chip-ic {
    width: 32px;
    height: 32px;
    border-radius: 9px;
    background: #fff;
    color: #509540;
    border: 1px solid #d8eed2;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .ph-chip-label {
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 1.2px;
    color: #509540;
    text-transform: uppercase;
    margin-bottom: 2px;
  }

  .ph-chip-val {
    font-size: 13.5px;
    font-weight: 700;
    color: #1C2634;
  }

  .ph-na {
    color: #aaa;
    font-weight: 500;
    font-style: italic;
    font-size: 12.5px;
  }

  .ph-outstanding {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 14px;
    padding: 8px 14px;
    background: rgba(245,158,11,0.10);
    border: 1px solid rgba(245,158,11,0.30);
    color: #b45309;
    font-size: 12.5px;
    font-weight: 700;
    border-radius: 20px;
  }

  /* CTA bar */
  .ph-cta {
    background: linear-gradient(90deg, #f5fbf2, #eef7eb);
    border-top: 1px solid #e8eee5;
    padding: 16px 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
  }

  .ph-cta-text {
    display: flex;
    align-items: center;
    gap: 10px;

    p {
      font-size: 13.5px;
      color: #1C2634;
      font-weight: 500;
      margin: 0;
    }
  }

  button {
    max-width: 170px;
    height: 44px;
    font-size: 14px;
    font-weight: 700;
    background: linear-gradient(135deg, #509540, #3d7a30) !important;
    border-radius: 10px !important;
    border: none !important;
    box-shadow: 0 6px 16px rgba(80,149,64,0.30) !important;
  }

  @media only screen and (max-width: 768px) {
    .ph-top { flex-direction: column; align-items: center; text-align: center; }
    .ph-info { text-align: center; }
    .ph-chips { grid-template-columns: 1fr; max-width: 100%; }
    .ph-chip { justify-content: flex-start; }
    .ph-cta { flex-direction: column; align-items: stretch; text-align: center; }
    .ph-cta-text { justify-content: center; }
  }
`;


export const DetailBoxWrapper = styled.div`
  background: #fff;
  border: 1px solid #e8eee5;
  box-shadow: 0 4px 18px rgba(28,38,52,0.05);
  border-radius: 16px;
  padding: 24px;
  transition: all 0.25s;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 3px;
    background: linear-gradient(90deg, #509540, #6dd05a);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.4s;
  }

  &:hover {
    border-color: #509540;
    box-shadow: 0 12px 28px rgba(80,149,64,0.12);
    transform: translateY(-3px);

    &::before { transform: scaleX(1); }
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    padding-bottom: 14px;
    border-bottom: 1px solid #eef2eb;

    h2 {
      font-size: 17px;
      line-height: 1.3;
      font-weight: 800;
      color: #1C2634;
      font-family: 'Poppins', sans-serif;
    }

    .icons {
      color: #509540;
      background: #f0f7ed;
      border: 1px solid #d8eed2;
      font-weight: 600;
      cursor: pointer;
      border-radius: 8px;
      height: 30px;
      padding: 0 12px;
      transition: all 0.25s;
      gap: 6px;
      display: flex;
      align-items: center;
      font-size: 12.5px;

      img {
        width: 13px;
        filter: brightness(0) saturate(100%) invert(45%) sepia(40%) saturate(560%) hue-rotate(70deg) brightness(95%) contrast(85%);
      }

      &:hover {
        color: #fff;
        background: linear-gradient(135deg, #509540, #3d7a30);
        border-color: #509540;
        img { filter: brightness(0) invert(1); }
      }
    }
  }

  .main {
    margin-top: 18px;

    table {
      border: none;
      width: 100%;
      border-collapse: collapse;

      tr {
        border-bottom: 1px solid #f4f7f2;

        &:last-child { border-bottom: none; }

        td {
          padding: 10px 0;
          font-size: 13.5px;
          line-height: 1.4;
          color: #1C2634;
          font-family: 'Poppins', sans-serif;

          &:first-child {
            padding-right: 20px;
            color: #6f7878;
            font-weight: 500;
          }
          &:last-child {
            font-weight: 700;
            text-align: right;
            color: #1C2634;
          }
        }
      }
    }
  }
`;


export const ProfilePreviewWrapper = styled.div`
  & > h2 {
    font-size: 1.4rem;
    font-weight: 800;
    color: #1C2634;
    margin: 4px 0 18px !important;
    font-family: 'Poppins', sans-serif;
    letter-spacing: -0.3px;
  }

  .detailBox {
    margin-block: 28px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;

    & > div {
      flex: none;
      min-width: 0;
      margin-left: 0;
    }

    @media only screen and (max-width: 992px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media only screen and (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }
`;
